<template>
    <AppHead title="Dashboard" />
    <div class="px-4 md:px-8">
        <DashboardEditBanner v-if="dashboardStore.isEditMode" />
        <div
            v-else
            class="md:flex md:items-center md:justify-between md:rounded-lg border-0"
        >
            <div class="min-w-0 flex-1">
                <!-- Profile -->
                <div class="flex flex-col px-4 md:px-0">
                    <div
                        class="flex flex-col md:flex-row justify-between items-start md:items-center"
                    >
                        <h1
                            class="text-left text-xl font-bold leading-7 text-gray-900 dark:text-gray-100 sm:truncate sm:leading-9"
                        >
                            <good-day></good-day>
                            <span>,&nbsp;{{ userData.name }}</span>
                            <span class="text-1xl ml-2">👋</span>
                        </h1>
                    </div>
                    <div
                        class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1"
                    >
                        <p
                            class="text-left text-base font-medium text-gray-800 dark:text-gray-300"
                        >
                            Welcome Back!
                        </p>
                        <button
                            type="button"
                            class="hidden lg:flex items-center gap-1.5 text-sm font-medium text-slate-800 dark:text-slate-200 hover:text-slate-600 dark:hover:text-slate-400 transition-colors rounded"
                            @click="dashboardStore.enterEditMode()"
                        >
                            <Icon icon="grid-add" :width="16" :height="16" />
                            Customize dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="csrBanner" class="pt-6 w-full max-w-9xl mx-auto">
            <SapphireReserveBanner
                :eligible="csrBanner.eligible"
                :dismissed-at="csrBanner.dismissedAt"
                :campaign-active="csrBanner.campaignActive"
                :cta-url="csrBanner.ctaUrl"
                :dismiss-url="csrBanner.dismissUrl"
            />
        </div>

        <Dashboard></Dashboard>
        <AffiliateDisclosureModal></AffiliateDisclosureModal>
        <ChaseModal
            v-if="cspModal"
            :eligible="cspModal.eligible"
            :dismissed-at="cspModal.dismissedAt"
            :campaign-active="cspModal.campaignActive"
            :cta-url="cspModal.ctaUrl"
            :dismiss-url="cspModal.dismissUrl"
        />
        <CoVentureBusinessModal
            v-if="c1vbModal"
            :eligible="c1vbModal.eligible"
            :dismissed-at="c1vbModal.dismissedAt"
            :campaign-active="c1vbModal.campaignActive"
            :cta-url="c1vbModal.ctaUrl"
            :dismiss-url="c1vbModal.dismissUrl"
            :card-image-url="c1vbModal.cardImageUrl"
        />
    </div>
</template>

<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed, onBeforeUnmount } from 'vue';
import Layout from '@/Layouts/Main.vue';
import AppHead from '@/Partials/AppHead.vue';
import Dashboard from '@/components/dashboard/index.vue';
import AffiliateDisclosureModal from '@/modals/affiliate-disclosure-modal.vue';
import GoodDay from '@/components/good-day.vue';
import Icon from '@/components/ui/icon/icon.vue';
import DashboardEditBanner from '@/components/dashboard/dashboard-edit-banner.vue';
import SapphireReserveBanner from '@/components/dashboard/cards/sapphire-reserve-banner.vue';
import ChaseModal from '@/components/popups/chase-modal.vue';
import CoVentureBusinessModal from '@/components/popups/co-venture-business-modal.vue';
import { useDashboardStore } from '@/store/dashboard';

const userData = computed(() => usePage().props.userData);
const csrBanner = computed(() => usePage().props.csrBanner);
const cspModal = computed(() => usePage().props.cspModal);
const c1vbModal = computed(() => usePage().props.c1vbModal);
const dashboardStore = useDashboardStore();

onBeforeUnmount(() => {
    if (dashboardStore.isEditMode) {
        dashboardStore.cancelEditMode();
    }
});
</script>
